import cn from 'bem-cn';

import { Divider, Skeleton, Stack } from '../../UI';

import './PromptInfoBody.scss';

const b = cn('prompt-info-body');

const CONTENT_SKELETON_WIDTHS = ['100%', '95%', '98%', '92%', '96%', '88%', '94%', '90%', '88%'];

export const PromptInfoBodySkeleton = () => {
    return (
        <Stack spacing={24} className={b()}>
            <Stack direction="row" justifyContent="center">
                <Skeleton
                    variant="rounded"
                    width={190}
                    height={40}
                    className={b('switch')}
                    style={{ borderRadius: 100 }}
                />
            </Stack>
            <Skeleton className={b('guide')} />
            <Divider />
            <Stack spacing={8} className={b('content')}>
                {CONTENT_SKELETON_WIDTHS.map((width, index) => (
                    <Skeleton key={index} width={width} />
                ))}
            </Stack>
        </Stack>
    );
};
